import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { user_company_users_delete, user_company_users_list } from "../user.api";
import Loader from "../../../components/loader/loader";
import BreadCrumpBack from "../../../components/navigator/back";
import "./style.css";

export default function CompanyUserView(props) {
  const { id } = useParams();
  const history = useHistory();
  const [userData, setUserData] = useState(null);
  const [isActive, setIsActive] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);

  useEffect(() => {
    if (id) {
      fetchUserDetails();
    }
  }, [id]);

  const fetchUserDetails = () => {
    setIsActive(true);
    user_company_users_list().then((res) => {
      const users = res.data || [];
      const user = users.find(u => u.id === parseInt(id));
      if (user) {
        setUserData(user);
      }
      setIsActive(false);
    }).catch((error) => {
      console.error("Error fetching user details:", error);
      setIsActive(false);
    });
  };

  const handleEdit = () => {
    history.push(`/directory-company-users/edit/${id}`);
  };

  const handleDelete = () => {
    if (window.confirm("Are you sure you want to delete this company user?")) {
      setIsActive(true);
      user_company_users_delete(id)
        .then((res) => {
          setSnackMessage("Company user deleted successfully");
          setIsSnackError(false);
          setSnackOpen(true);
          setTimeout(() => {
            history.push("/directory-company-users");
          }, 1500);
        })
        .catch((error) => {
          setSnackMessage(error.message || "Failed to delete user");
          setIsSnackError(true);
          setSnackOpen(true);
          setIsActive(false);
        });
    }
  };

  const snackbarClose = () => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
  };

  if (!userData) {
    return (
      <div className="tender bg-tender">
        <Loader open={isActive} />
        <div className="no-data">
          <h4>User not found</h4>
        </div>
      </div>
    );
  }

  return (
    <div className="tender bg-tender">
      <Loader open={isActive} />
      <div>
        <div className="dash-banner">
          <div className="tit-txt">
            {props.state.language === "ma"
              ? "കമ്പനി ഉപയോക്താവിവരങ്ങൾ"
              : "Company User Details"}
          </div>
        </div>
        <BreadCrumpBack />
      </div>
      <div className="container p-50">
        <div className="user-detail-container">
          <div className="row">
            <div className="col-md-4">
              <div className="profile-section">
                <img
                  src="resources/img/default-avatar.png"
                  alt={userData.name}
                  className="profile-avatar"
                />
                <h3>{userData.name || "N/A"}</h3>
                <p className="designation">{userData.role || "N/A"}</p>
                <div className="mt-2">
                  <span className={`badge ${userData.status === 1 ? 'badge-success' : 'badge-secondary'}`}>
                    {userData.status === 1 ? 'Active' : 'Inactive'}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-8">
              <div className="details-section">
                <h4>Personal Information</h4>
                <div className="detail-row">
                  <span className="label">Email:</span>
                  <span className="value">{userData.email || "N/A"}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Mobile:</span>
                  <span className="value">{userData.mobile_number || "N/A"}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Role:</span>
                  <span className="value">{userData.role || "N/A"}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Status:</span>
                  <span className="value">
                    <span className={`badge ${userData.status === 1 ? 'badge-success' : 'badge-secondary'}`}>
                      {userData.status === 1 ? 'Active' : 'Inactive'}
                    </span>
                  </span>
                </div>
                
                <h4 className="mt-4">Account Information</h4>
                <div className="detail-row">
                  <span className="label">User ID:</span>
                  <span className="value">{userData.id || "N/A"}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Created At:</span>
                  <span className="value">{userData.created_at ? new Date(userData.created_at).toLocaleDateString() : "N/A"}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Last Login:</span>
                  <span className="value">{userData.last_login_at ? new Date(userData.last_login_at).toLocaleDateString() : "Never"}</span>
                </div>

                <div className="action-buttons mt-4">
                  <button
                    className="btn btn-primary mr-2"
                    onClick={handleEdit}
                  >
                    Edit
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={handleDelete}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
